import { downloadUrl } from "@/constant/download";
import $device from "@/lib/device";

const jumpToDownload = () => {
  const { isIPhone, isAndroid, isWeChat } = $device;
  if (isIPhone && !isWeChat) {
    window.location.href = downloadUrl.iphone;
  } else if (isAndroid && !isWeChat) {
    window.location.href = downloadUrl.android;
  } else {
    window.location.href = downloadUrl.web;
  }
};

export default jumpToDownload;
